module.exports = __webpack_public_path__ + "img/logo-paninti-header.9f45b4c.svg";